// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/bg_img_min.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-input-placeholder {
    color: #BCBCBC;
    opacity: 1;
}
*:-moz-placeholder {
    color: #BCBCBC;
    opacity: 1;
}
*::-moz-placeholder {
    color: #BCBCBC;
    opacity: 1;
}
*:-ms-input-placeholder {
    color: #BCBCBC;
    opacity: 1;
}

body input:focus:required:invalid,
body textarea:focus:required:invalid {

}
body input:required:valid,
body textarea:required:valid {

}

html.js .loader {
    background: none repeat scroll 0 0 #ffffff;
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 9999;
}
html.js .loader_inner {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #fff;
    height: 60px;
    width: 60px;
    margin-top: -30px;
    margin-left: -30px;
    left: 50%;
    top: 50%;
    position: absolute;
}

body {
    font-family: sans-serif;
    font-size: 16px;
    min-width: 320px;
    position: relative;
    line-height: normal;
    font-family: "Montserrat", sans-serif;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
}
.hidden {
    display: none;
}

main {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0;
    padding: 80px 0;
    background-size: cover;
    min-height: 100vh;
    position: relative;
}
.mainpage {
    display: flex;
    gap: 0px;
    align-items: center;
}
.left {
    width: 55%;
}
h1 {
    color: #000;
    font-size: 44px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0;
    margin-bottom: 36px;
}
.form {
    border-radius: 20px;
    background: #FFF;
    padding: 45px 60px 25px;
    display: flex;
    flex-direction: column;
    gap: 26px;
    max-width: 490px;
}
.form-title {
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.form input {
    border-radius: 8px;
    background: #F8F8F8;
    padding: 22px 26px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    border: 2px solid rgba(238, 238, 238, 0.54);
    width: 100%;
    font-family: Montserrat;
}
.form input:focus-visible {
    outline: none;
}

button:focus {
    outline: none;
}

.form input.error {
    border: 1px solid #FFCDCD;
}

.form input.error::-webkit-input-placeholder {
    color: #FF4B4B;
    opacity: 1;
}
.form input.error:-moz-placeholder {
    color: #FF4B4B;
    opacity: 1;
}
.form input.error::-moz-placeholder {
    color: #FF4B4B;
    opacity: 1;
}
.form input.error:-ms-input-placeholder {
    color: #FF4B4B;
    opacity: 1;
}
.form-data {
    border-radius: 9px;
    background: #F8F8F8;
    text-align: center;
    color: #000;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 22px;
}
.form-text {
    color: #000;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.form-btn {
    cursor: pointer;
    background: #000;
    color: #fff;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
    padding: 22px 0;
    border-radius: 8px;
    border: none;
}

.form-btn:hover {
    background: #3F3F3F;
}
.right {
    width: 45%;
}
.right img {
    max-width: 100%;
    width: 100%;
    height: auto;
}

.error-text {
    color: #FF4B4B;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    min-height: 20px;
    text-align: center;
}
.mobile-img {
    display: none;
}
/*==========  Desktop First Method  ==========*/

/* Large Devices, Wide Screens */
@media only screen and (max-width: 1200px) {

}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
    main {
        background-position-x: right;
    }
    .left {
        width: 100%;
    }
    .right {
        display: none;
    }
    .form {
        margin: 0 auto;
    }

}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {

    /*Disable Animation on Mobile Devices*/
    .animated {
        /*CSS transitions*/
        transition-property: none !important;
        /*CSS transforms*/
        transform: none !important;
        /*CSS animations*/
        animation: none !important;
    }
    main {
        padding-top: 40px;
    }
    h1 {
        font-size: 24px;
        margin-bottom: 25px;
    }
    .form {
        max-width: 100%;
        padding: 20px;
        box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
    }
    .container {
        padding-left: 30px;
        padding-right: 30px;
    }

}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 576px) {
    main {
        padding-bottom: 170px;
    }
    .form {
        gap: 15px;
    }

    .form-title {
        font-size: 16px;
    }
    .form input {
        padding: 12px 15px;
        font-size: 13px;
    }
    .form-data {
        font-size: 13px;
        padding: 12px;
    }
    .form-text {
        font-size: 13px;
    }
    .form-btn {
        padding: 12px 15px;
    }
    .mobile-img {
        display: flex;
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .mobile-img img {
        width: 100%;
        max-width: 100%;
        height: auto;
    }

}

/* Custom, iPhone Retina */
@media only screen and (max-width: 350px) {
    .container {
        padding-left: 15px;
        padding-right: 15px;
    }
}


/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {

}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {

}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {

}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {

}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {

}

.helper-wrapper{
    display: flex;
}

.helper-wrapper h1{
    margin-top: 5px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 450;
    margin-bottom: 0px;
    line-height: 18px;
}

.helper-wrapper p{
    margin-left: 10px;
    margin-top: 0px;
    font-size: 14px;
    font-weight: 100;
    line-height: 18px;
}

.helper-wrapper img{

}

.link-balance{
    color: #1b1e21;
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/assets/main.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;;;AAGA;AACA;;;AAGA;;AAEA;IACI,0CAA0C;IAC1C,SAAS;IACT,YAAY;IACZ,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,WAAW;IACX,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iEAA2D;IAC3D,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IAGI,aAAa;IACb,QAAQ;IAGR,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IAGvB,aAAa;IAIb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA,+CAA+C;;AAE/C,gCAAgC;AAChC;;AAEA;;AAEA,6BAA6B;AAC7B;IACI;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;;AAEJ;;AAEA,2BAA2B;AAC3B;;IAEI,sCAAsC;IACtC;QACI,kBAAkB;QAGlB,oCAAoC;QACpC,iBAAiB;QAGjB,0BAA0B;QAC1B,iBAAiB;QAEjB,0BAA0B;IAC9B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,aAAa;QAEb,2CAA2C;IAC/C;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;AAEJ;;AAEA,gCAAgC;AAChC;IACI;QACI,qBAAqB;IACzB;IACA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QAGI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,QAAQ;IACZ;IACA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;AAEJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;;AAGA,8CAA8C;;AAE9C,0BAA0B;AAC1B;;AAEA;;AAEA,gCAAgC;AAChC;;AAEA;;AAEA,2BAA2B;AAC3B;;AAEA;;AAEA,6BAA6B;AAC7B;;AAEA;;AAEA,gCAAgC;AAChC;;AAEA;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":["*::-webkit-input-placeholder {\r\n    color: #BCBCBC;\r\n    opacity: 1;\r\n}\r\n*:-moz-placeholder {\r\n    color: #BCBCBC;\r\n    opacity: 1;\r\n}\r\n*::-moz-placeholder {\r\n    color: #BCBCBC;\r\n    opacity: 1;\r\n}\r\n*:-ms-input-placeholder {\r\n    color: #BCBCBC;\r\n    opacity: 1;\r\n}\r\n\r\nbody input:focus:required:invalid,\r\nbody textarea:focus:required:invalid {\r\n\r\n}\r\nbody input:required:valid,\r\nbody textarea:required:valid {\r\n\r\n}\r\n\r\nhtml.js .loader {\r\n    background: none repeat scroll 0 0 #ffffff;\r\n    bottom: 0;\r\n    height: 100%;\r\n    left: 0;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 9999;\r\n}\r\nhtml.js .loader_inner {\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    background-color: #fff;\r\n    height: 60px;\r\n    width: 60px;\r\n    margin-top: -30px;\r\n    margin-left: -30px;\r\n    left: 50%;\r\n    top: 50%;\r\n    position: absolute;\r\n}\r\n\r\nbody {\r\n    font-family: sans-serif;\r\n    font-size: 16px;\r\n    min-width: 320px;\r\n    position: relative;\r\n    line-height: normal;\r\n    font-family: \"Montserrat\", sans-serif;\r\n    overflow-x: hidden;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\nmain {\r\n    background: url(../assets/img/bg_img_min.jpg) no-repeat 0 0;\r\n    padding: 80px 0;\r\n    background-size: cover;\r\n    min-height: 100vh;\r\n    position: relative;\r\n}\r\n.mainpage {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    gap: 0px;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.left {\r\n    width: 55%;\r\n}\r\nh1 {\r\n    color: #000;\r\n    font-size: 44px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n    margin: 0;\r\n    margin-bottom: 36px;\r\n}\r\n.form {\r\n    border-radius: 20px;\r\n    background: #FFF;\r\n    padding: 45px 60px 25px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    gap: 26px;\r\n    max-width: 490px;\r\n}\r\n.form-title {\r\n    color: #000;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n}\r\n\r\n.form input {\r\n    border-radius: 8px;\r\n    background: #F8F8F8;\r\n    padding: 22px 26px;\r\n    color: #000;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 23px;\r\n    border: 2px solid rgba(238, 238, 238, 0.54);\r\n    width: 100%;\r\n    font-family: Montserrat;\r\n}\r\n.form input:focus-visible {\r\n    outline: none;\r\n}\r\n\r\nbutton:focus {\r\n    outline: none;\r\n}\r\n\r\n.form input.error {\r\n    border: 1px solid #FFCDCD;\r\n}\r\n\r\n.form input.error::-webkit-input-placeholder {\r\n    color: #FF4B4B;\r\n    opacity: 1;\r\n}\r\n.form input.error:-moz-placeholder {\r\n    color: #FF4B4B;\r\n    opacity: 1;\r\n}\r\n.form input.error::-moz-placeholder {\r\n    color: #FF4B4B;\r\n    opacity: 1;\r\n}\r\n.form input.error:-ms-input-placeholder {\r\n    color: #FF4B4B;\r\n    opacity: 1;\r\n}\r\n.form-data {\r\n    border-radius: 9px;\r\n    background: #F8F8F8;\r\n    text-align: center;\r\n    color: #000;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n    padding: 22px;\r\n}\r\n.form-text {\r\n    color: #000;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n}\r\n.form-btn {\r\n    cursor: pointer;\r\n    background: #000;\r\n    color: #fff;\r\n    text-align: center;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    width: 100%;\r\n    padding: 22px 0;\r\n    border-radius: 8px;\r\n    border: none;\r\n}\r\n\r\n.form-btn:hover {\r\n    background: #3F3F3F;\r\n}\r\n.right {\r\n    width: 45%;\r\n}\r\n.right img {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.error-text {\r\n    color: #FF4B4B;\r\n    font-size: 12px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    min-height: 20px;\r\n    text-align: center;\r\n}\r\n.mobile-img {\r\n    display: none;\r\n}\r\n/*==========  Desktop First Method  ==========*/\r\n\r\n/* Large Devices, Wide Screens */\r\n@media only screen and (max-width: 1200px) {\r\n\r\n}\r\n\r\n/* Medium Devices, Desktops */\r\n@media only screen and (max-width: 992px) {\r\n    main {\r\n        background-position-x: right;\r\n    }\r\n    .left {\r\n        width: 100%;\r\n    }\r\n    .right {\r\n        display: none;\r\n    }\r\n    .form {\r\n        margin: 0 auto;\r\n    }\r\n\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n@media only screen and (max-width: 768px) {\r\n\r\n    /*Disable Animation on Mobile Devices*/\r\n    .animated {\r\n        /*CSS transitions*/\r\n        -o-transition-property: none !important;\r\n        -webkit-transition-property: none !important;\r\n        transition-property: none !important;\r\n        /*CSS transforms*/\r\n        -ms-transform: none !important;\r\n        -webkit-transform: none !important;\r\n        transform: none !important;\r\n        /*CSS animations*/\r\n        -webkit-animation: none !important;\r\n        animation: none !important;\r\n    }\r\n    main {\r\n        padding-top: 40px;\r\n    }\r\n    h1 {\r\n        font-size: 24px;\r\n        margin-bottom: 25px;\r\n    }\r\n    .form {\r\n        max-width: 100%;\r\n        padding: 20px;\r\n        -webkit-box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;\r\n        box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;\r\n    }\r\n    .container {\r\n        padding-left: 30px;\r\n        padding-right: 30px;\r\n    }\r\n\r\n}\r\n\r\n/* Extra Small Devices, Phones */\r\n@media only screen and (max-width: 576px) {\r\n    main {\r\n        padding-bottom: 170px;\r\n    }\r\n    .form {\r\n        gap: 15px;\r\n    }\r\n\r\n    .form-title {\r\n        font-size: 16px;\r\n    }\r\n    .form input {\r\n        padding: 12px 15px;\r\n        font-size: 13px;\r\n    }\r\n    .form-data {\r\n        font-size: 13px;\r\n        padding: 12px;\r\n    }\r\n    .form-text {\r\n        font-size: 13px;\r\n    }\r\n    .form-btn {\r\n        padding: 12px 15px;\r\n    }\r\n    .mobile-img {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        position: absolute;\r\n        bottom: 0;\r\n        right: 0;\r\n    }\r\n    .mobile-img img {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n}\r\n\r\n/* Custom, iPhone Retina */\r\n@media only screen and (max-width: 350px) {\r\n    .container {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n}\r\n\r\n\r\n/*==========  Mobile First Method  ==========*/\r\n\r\n/* Custom, iPhone Retina */\r\n@media only screen and (min-width: 320px) {\r\n\r\n}\r\n\r\n/* Extra Small Devices, Phones */\r\n@media only screen and (min-width: 480px) {\r\n\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n@media only screen and (min-width: 768px) {\r\n\r\n}\r\n\r\n/* Medium Devices, Desktops */\r\n@media only screen and (min-width: 992px) {\r\n\r\n}\r\n\r\n/* Large Devices, Wide Screens */\r\n@media only screen and (min-width: 1200px) {\r\n\r\n}\r\n\r\n.helper-wrapper{\r\n    display: flex;\r\n}\r\n\r\n.helper-wrapper h1{\r\n    margin-top: 5px;\r\n    margin-left: 10px;\r\n    font-size: 14px;\r\n    font-weight: 450;\r\n    margin-bottom: 0px;\r\n    line-height: 18px;\r\n}\r\n\r\n.helper-wrapper p{\r\n    margin-left: 10px;\r\n    margin-top: 0px;\r\n    font-size: 14px;\r\n    font-weight: 100;\r\n    line-height: 18px;\r\n}\r\n\r\n.helper-wrapper img{\r\n\r\n}\r\n\r\n.link-balance{\r\n    color: #1b1e21;\r\n    text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
